import { attachment, list } from '@/router/utils'
import { AttachmentUploader } from '@/shared/components/attachment-uploader'
import { LinkWithQuery } from '@/shared/components/link-with-query'
import { useGetAttachmentTypesQuery } from '@/store/services/attachment-type.service'
import { useCreateAttachmentMutation, useGetAttachmentsQuery, useUpdateAttachmentMutation } from '@/store/services/attachment.service'
import { Button, Dialog, DialogBody, DialogFooter, DialogHeader } from '@material-tailwind/react'
import { FiArrowLeft } from 'react-icons/fi'
import { createSearchParams, useLoaderData } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export const AssetAttachmentUpload = () => {
  const { t } = useTranslation()
  const { asset } = useLoaderData()

  const attachmentSearchParams = createSearchParams({
    attachable_type: 'Contractor::Asset',
    attachable_id: asset.id,
    per_page: 9999,
    'sorter[field]': 'id',
    'sorter[order]': 'desc'
  })

  const attachmentTypeSearchParams = createSearchParams({
    klass: 'Contractor::Asset',
    per_page: 9999
  })

  const { data: { attachmentTypes = [] } = {} } = useGetAttachmentTypesQuery(`?${attachmentTypeSearchParams}`)
  const { data: { attachments = [] } = {}, isLoading: isLoadingAttachments } = useGetAttachmentsQuery(`?${attachmentSearchParams}`)

  const [updateAttachment] = useUpdateAttachmentMutation()
  const [createAttachment] = useCreateAttachmentMutation()

  const onUpload = async (params) => {
    try {
      if (params?.id) {
        await updateAttachment(params).unwrap()
      } else {
        await createAttachment({ ...params, attachable_id: asset.id, attachable_type: 'Contractor::Asset' }).unwrap()
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Dialog size='lg' open={true}>
      <DialogHeader className='pb-0'>
        <LinkWithQuery to={attachment('assets', asset.id)}>
          <Button
            size='sm'
            className='w-fit flex items-center'
            variant='text'
          >
            <FiArrowLeft size='16px' className='mr-2' />
            Volver
          </Button>
        </LinkWithQuery>
      </DialogHeader>

      <DialogBody>
        {
          !isLoadingAttachments &&
          <AttachmentUploader
            attachableType='Contractor::Asset'
            attachmentTypes={attachmentTypes}
            showLatestAttachments
            attachments={attachments}
            onUpload={onUpload}
            restrictPastExpirationDates
            expirationDateNotice={t('common.uploadDocuments.pendingExpirationNotice', {
              entity: 'el activo'
            })}
          >
            {(handleSubmit) => (

              <Button
                className='w-fit'
                variant='outlined'
                onClick={handleSubmit}
              >
                Agregar documento
              </Button>
            )}
          </AttachmentUploader>
        }
      </DialogBody>

      <DialogFooter>
        <LinkWithQuery to={list('assets')}>
          <Button
            variant='outlined'
            color='white'
          >
            Salir
          </Button>
        </LinkWithQuery>
      </DialogFooter>
    </Dialog >
  )
}
